<template>
  <div>
    <label class="label"><slot /></label>
  </div>
</template>

<script>
export default {
  name: 'FormLabel',
}
</script>

<style scoped>
.label {
  display: block;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
}
</style>
